import * as React from "react";
import type { ProjectOrEnvironment } from "~/components/DeploymentFreezes/FrozenIcon";
import FrozenIcon from "~/components/DeploymentFreezes/FrozenIcon";
import styles from "./style.module.less";
export default (props: {
    for: ProjectOrEnvironment;
}) => (<span className={styles.dashboardIcon}>
        <FrozenIcon for={props.for}/>
    </span>);
